import React, { useEffect, useRef, useState } from 'react'
import { Content } from 'antd/es/layout/layout'
import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Collapse, Image, Select, Tooltip } from 'antd'
import { CFCDN, toAwning, toBlind, toCurtain } from '../../shop-front-component/ProductCollection'
import {  colourType, fabricType, Fabrics, powerType } from './data'
import { ArrowLeftOutlined,ArrowRightOutlined,LoadingOutlined } from '@ant-design/icons';
import { controlType, motoBrand } from './data'


export default function CurtainsPage() {
    const navigate = useNavigate()
    const [currentImage,setCurrentImage] = useState(CFCDN+"product-cover/single-curtain-cover.jpeg")
    const [currentImageList,setCurrentImageList] = useState([CFCDN+"product-cover/single-curtain-cover.jpeg",CFCDN+"Curtains/curtain-picture-2.jpg",CFCDN+"Curtains/curtain-picture-3.jpg",CFCDN+"Curtains/range.jpg",CFCDN+"Curtains/range1.jpg",CFCDN+"Curtains/range2.jpg",CFCDN+"Curtains/range3.jpg",CFCDN+"Curtains/range4.jpg",CFCDN+"Curtains/range5.jpg",CFCDN+"Curtains/range6.jpg"])
    const [currentFabric, setCurrentFabric] = useState<number>()
    const [currentFabrics, setCurrentFabrics] = useState<Fabrics[]>([])
    const [currentColour, setCurrentColour] = useState<number>()
    const [currentColourTitle, setCurrentColourTitle] = useState<string>("")
    const [currentColourList, setCurrentColourList] = useState<colourType[]>([])
    const [currentFabricType,setCurrentFabricType] = useState<number>()

 

    
    const [currentControlType, setCurrentControlType] = useState<number>()
    const [currentMotorBrand, setCurrentMotorBrand] = useState<number>()

    const [wifiControl,setWifiControl] = useState(false)
    const [controlTypes,setControlTypes] = useState([])
    const [control,setControl] = useState<number>()
   
    const [currentPowerType,setCurrentPowerType] = useState<number>()
   
    
    const   containerRef = useRef<HTMLDivElement>(null);;
    // useEffect(() => {
    //     // Initial load of images
    //     fetchMoreImages();
    // }, []);

  
    const scrollToParentEnd = (parentDevStr:string) => {
        const parentDiv = document.getElementById(parentDevStr); // Replace with your actual parent div id
        if (parentDiv) {
          const parentRect = parentDiv.getBoundingClientRect();
          window.scrollTo({
            top: parentRect.bottom + window.scrollY - window.innerHeight + 500,
            behavior: 'smooth',
          });
        }
      };
    

    useEffect(() => {
        const container = containerRef.current;
        
        const onScroll = () => {
            if (container){
                if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
                    // fetchMoreImages();
                }
            }
            
        };

        if (container) {
            container.addEventListener('scroll', onScroll);
        }

        return () => {
            if (container) {
                container.removeEventListener('scroll', onScroll);
            }
        };
    }, [currentImageList]);

    const fetchMoreImages = () => {
        // Mock fetching more images (replace with your actual fetch logic)
        const newImages = currentImageList
        setCurrentImageList(prevList => [...prevList, ...newImages]);
    };

    const handleScroll = (scrollOffset:number) => {
        if(containerRef.current){
            containerRef.current.scrollBy({ left: scrollOffset, behavior: 'smooth' });
        }   
        
    };   

    const handleFabricChanges = (e:any)=>{
        const fabricCatalog = currentFabrics.find(
            (item) => item.id === e,
          );
        if (fabricCatalog?.colours){
            loadFabricColor(fabricCatalog?.colours)
            setCurrentColourList(fabricCatalog?.colours) 
        }
    }

    /// LOAD MANAGEMENT

    const preloadImages = (srcArray: string[]): Promise<void[]> => {
        return Promise.all(
          srcArray.map(src => {
            return new Promise<void>((resolve, reject) => {
              const img = new window.Image();
              img.src = src;
              img.onload = () => resolve();
              img.onerror = reject;
            });
          })
        );
      };
    const [loading, setLoading] = useState(true);
    const [loadingFabricBrand, setLoadingFabricBrand] = useState(true);
    const [loadingFabricColor, setLoadingFabricColor] = useState(true);
  
    useEffect(() => {
        const imageSources = currentImageList.map(item => item);
        preloadImages(imageSources)
        .then(() => setLoading(false))
        .catch(err => {setLoading(false); console.error('Failed to preload images', err)})
    }, []);
    
    const loadFabricColor = (srcArray: colourType[]) =>{
        setLoadingFabricColor(true)
        const imageSources = srcArray.map(item => item.src);
        preloadImages(imageSources)
        .then(() => setLoadingFabricColor(false))
        .catch(err => {setLoadingFabricColor(false); console.error('Failed to preload images', err)})
    }
    const loadFabricBrand = (srcArray: colourType[]) =>{
        setLoadingFabricBrand(true)
        const imageSources = srcArray.map(item => item.src);
        preloadImages(imageSources)
        .then(() => setLoadingFabricBrand(false))
        .catch(err => {setLoadingFabricBrand(false); console.error('Failed to preload images', err)})
    }
   

    const [loadingRemote, setLoadingRemote] = useState(true);
    if (loading) {
        return  <div className='hedvig-letters-sans-regular  p-1 flex items-center justify-center h-[100vh] w-full bg-white'>
        <Content className=' bg-transparent max-w-screen-2xl m-auto px-2 flex items-center justify-center'>
            <LoadingOutlined color="#000000" style={{fontSize:40}}/>
        </Content>
        </div>
      }

      const loadRemote = (srcArray: colourType[]) =>{
        setLoadingRemote(true)
        const imageSources = srcArray.map(item => item.src);
        preloadImages(imageSources)
        .then(() => setLoadingRemote(false))
        .catch(err => {setLoadingRemote(false); console.error('Failed to preload images', err)})
    }
  return (
      <div className='hedvig-letters-sans-regular bg-white p-1'>
            <Content className=' bg-transparent max-w-screen-2xl m-auto px-2'>
                <div className=" mx-auto gap-5 h-[fit] mt-5">
                    <div className="flex flex-col lg:flex-row gap-5 ">
                        {/* Left Column */}
                        <div className=' w-full lg:w-7/12 '>
                            <div className='sticky top-32 '>
                                <div className='w-full flex justify-center aspect-video overflow-hidden shadow-md  border-none bg-white rounded-lg mx-auto overflow-hidden' >
                                                <Image
                                                    src={currentImage}      
                                                    alt="Centered Image"
                                                    height={"100%"}
                                              
                                                    className="transform object-cover object-center"
                                                /> 
                                                
                                </div>
                                <div className='relative gap-3 flex flex-row group justify-center items-center'>
                                    <div className=' absolute shrink-0 rounded-md left-0 z-50 bg-white !h-[3rem] !w-[3rem] opacity-30 flex items-center justify-center hover:opacity-100 group-hover:opacity-100 transform-all duration-300'
                                            onClick={()=>{handleScroll(-300)}}
                                        >
                                            <span className='text-black'><ArrowLeftOutlined></ArrowLeftOutlined></span>
                                        </div>
                                    <div className='relative flex flex-row gap-2 mt-2 overflow-scroll no-scrollbar p-2 scroll-smooth'
                                        ref={containerRef}
                                    >
                                    
                                        {currentImageList.map((item,index)=>{
                                            return(
                                                <div key={index}
                                                    onClick={()=>{setCurrentImage(item)}}
                                                >
                                                    <img
                                                    className={`object-center object-cover w-[10rem] aspect-video rounded-lg shadow-md  ${(currentImage == item)?'border-2 border-solid  border-blue-500 ' :'border border-solid  border-gray-100'} transform-all duration-100`}
                                                    alt=""
                                                    src={item}
                                                    
                                                />
                                                </div>
                                                
                                            )
                                        })}
                                        
                                    </div>
                                    <div className='absolute shrink-0 rounded-md right-0 z-50 bg-white !h-[3rem] !w-[3rem] opacity-30 flex items-center justify-center hover:opacity-100 group-hover:opacity-100 transform-all duration-300'
                                            onClick={()=>{handleScroll(300)}}
                                        >
                                            <span className='text-black'><ArrowRightOutlined></ArrowRightOutlined></span>
                                        </div>
                                    </div>
                                    
                            </div>
                            
                        </div>

                        {/* Right Column */}
                        
                        <div className="w-full lg:w-5/12  border-none flex flex-col lg:pl-5">
                        <div className='flex flex-row  mt-10 justify-between p-2'>
                            <Breadcrumb
                                items={[
                                {
                                    title: <span onClick={()=>{navigate('/')}} className=' hover:underline hover:-translate-y-1 duration-300 transition-transform '>Home</span>,
                                },
                                {
                                    title: <span onClick={()=>{navigate('/products/curtains')}} className=' hover:underline hover:-translate-y-1 duration-200 transition-transform '>Curtains</span>,
                                },
                                {
                                    title: 'Curtains',
                                },
                                ]}
                            />
                        
                        </div>
            
                        <div className=' w-full  flex flex-col'>
                            {/* <span className='hedvig-letters-serif-regular text-6xl  my-5'>
                                Protecta Zip Awnings
                            </span> */}
                            <div className=' flex flex-col my-5 h-fit '>
                                <span className='hedvig-letters-serif-regular text-6xl '>
                                    Curtains
                                </span>
                                <span className='hedvig-letters-sans-regular text-xl text-neutral-700 mt-5 '>
                                    From $518.38
                                </span>
                                <span className='hedvig-letters-sans-regular text-lg text-neutral-500 mt-5 '>
                                {'Explore our versatile curtain collection, featuring sheer and blackout options alongside motorized curtains for added convenience. Elevate your space with elegance and functionality, effortlessly controlling light and privacy while complementing any decor.'}
                                </span>
                        
                       
                            </div>
                            <Collapse
                                
                                size='large'
                                defaultActiveKey={['1']}
                                className='my-2'
                                items={[{ key: '1', label: 'Fabric'
                                , children:  
                                <div>
                                    <div className={`w-full mb-5 flex flex-col`} id={'fabricType'}>
                                    <span className='hedvig-letters-sans-regular text-xl text-black mb-3'>Select Fabric:</span>
                                    <div className='flex flex-col gap-3'>
                                            {fabricType?.map((item:any,index:number) =>{
                                                    return(
                                                    
                                                            <div
                                                            key={index}
                                                            className={`bg-white w-full h-fit cursor-pointer flex flex-row items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(currentFabricType == index)?'border-2 border-solid  border-blue-500 ' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                            onClick={()=>{
                                                            // handleFabricChanges(item.id)
                                                            setCurrentFabricType(index)
                                                            setCurrentFabrics(item.fabrics)
                                                            loadFabricBrand(item.fabrics)
                                                            setCurrentFabric(undefined)
                                                            setCurrentColour(undefined)
                                                            scrollToParentEnd('fabricType')
                                                            }}
                                                            >
                                                                
                                                                    <img
                                                                    
                                                                        className="object-center  w-1/3  m-1"
                                                                        alt=""
                                                                        src={item.src}
                                                                    />
                                                                    <div className='flex flex-col p-2 h-full w-2/3'>
                                                                        <span className='text-base lg:text-lg'>{item.title}</span>
                                                                        {item.desc.map((i:string,index:number)=>{
                                                                        return(
                                                                            <div key={index} className='flex flex-row gap-2'>
                                                                            <span className='text-sm lg:text-sm text-neutral-500'>•</span>
                                                                            <span className='text-sm lg:text-sm text-neutral-500'>{i}</span>
                                                                            </div>
                                                                            
                                                                        )
                                                                        })}
                                                                        
                                                                    </div>
                                                                
                                                            </div>
                                            
                                                    )
                                            })}
                                        
                                        </div>
                                            </div>
                                            <div className={`w-full mt-5 mb-5 flex flex-col ${currentFabricType==undefined? 'hidden':''}`} id={'fabricBrand'}>
                                                <span className={`hedvig-letters-sans-regular text-xl text-black mb-3`}>Fabric Brand:</span>
                                                {(loadingFabricBrand)?
                                                    <div className='flex items-center justify-center'>
                                                         <LoadingOutlined color="#000000" style={{fontSize:40}}/>
                                                    </div>
                                                   
                                                    :
                                                <div className={`grid grid-cols-2 xl:grid-cols-3 gap-3`}>
                                                {currentFabrics?.map((item:any,index:number) =>{
                                                        return(
                                                        
                                                                <div
                                                                key={index}
                                                                
                                                                className={`bg-white cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(currentFabric == index)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                                onClick={()=>{
                                                                handleFabricChanges(item.id)
                                                                setCurrentFabric(index)
                                                                setCurrentColour(undefined)
                                                                scrollToParentEnd('fabricBrand')

                                                                }}
                                                                >
                                                                    
                                                                        <img
                                                                        
                                                                            className="object-center object-cover w-full h-full"
                                                                            alt=""
                                                                            src={item.src}
                                                                        />
                                                                        <div className='flex flex-col p-2'>
                                                                            <span className='text-sm '>{item.title}</span>
                                                                            {/* <span className='text-sm text-neutral-500'>{item.desciption}</span> */}
                                                                        </div>
                                                                            
                                                                </div>
                                                        
                                                                )
                                                        })}
                                                    
                                                    </div>}
                                                        </div>
                                            <div className={`flex flex-col  mt-5 ${currentFabric==undefined ? 'hidden':''}`} id={'fabricColor'}>
                                                <span className='hedvig-letters-sans-regular text-xl text-black mb-3'>Fabric Color:</span>
                                                    {(loadingFabricColor)?
                                                    <div className='flex items-center justify-center'>
                                                         <LoadingOutlined color="#000000" style={{fontSize:40}}/>
                                                    </div>
                                                   
                                                    :<div className='grid grid-cols-3 xl:grid-cols-4 gap-3'>
                                                        {currentColourList?.map((item:any,index:number) =>{
                                                                return(
                                                                
                                                                        <div
                                                                        key={index}
                                                                        
                                                                        className={`bg-white aspect-square cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(currentColour == index)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                                        onClick={()=>{
                                                                            setCurrentImage(item.src);
                                                                            setCurrentColour(index)
                                                                            setCurrentColourTitle(item.title)
                                                                            // scrollToParentEnd('fabricColor')
                                                                        }}
                                                                        >
                                                                            
                                                                                <img
                                                                                
                                                                                    className="object-center object-cover w-full h-full "
                                                                                    alt=""
                                                                                    src={item.src}
                                                                                />
                                                                    
                                                                            <span className='text-sm my-2'>{item.title}</span>
                                                                        </div>
                                                        
                                                                )
                                                        })}
                                                    
                                                    </div>}
                                                    
                                            </div>
                                        </div>
                            }]}
                            />
                             
                             <Collapse
                                    
                                    size='large'
                                    defaultActiveKey={['1']}
                                    className='my-2 '
                                    items={[{ key: '1', label: 'Control', 
                                    children: 
                                    <div>
                                        <div className={`w-full mb-5 flex flex-col`} id='controlType'>
                                    <span className='hedvig-letters-sans-regular text-xl text-black mb-3'>Control:</span>
                                    <div className='flex flex-row gap-3 '>
                                        {controlType?.map((item:any,index:number) =>{
                                                return(
                                                
                                                        <div
                                                        key={index}
                                                        
                                                        className={`bg-white w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(currentControlType == index)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setCurrentControlType(index)
                                                            setControl(undefined)
                                                            setWifiControl(false)
                                                            scrollToParentEnd('controlType')
                                                   
                                                        }}
                                                        >
                                                            
                                                                <img
                                                                
                                                                    className="object-center object-cover w-full aspect-square"
                                                                    alt=""
                                                                    src={item.src}
                                                                />
                                                    
                                                            <span className='text-sm my-2'>{item.title}</span>
                                                        </div>
                                        
                                                )
                                        })}
                                    
                                    </div>
                                </div>
                                <div className={`w-full mt-5 mb-5 flex flex-col ${currentControlType==1 ? '':'hidden'}`} id='motorBrand'>
                                    <span className='hedvig-letters-sans-regular text-xl text-black mb-3'>Motor Brand:</span>
                                    <div className='grid grid-cols-3 gap-3'>
                                        {motoBrand?.map((item:any,index:number) =>{
                                                return(
                                                
                                                        <div
                                                        key={index}
                                                        className={`bg-white cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(currentMotorBrand == index)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setCurrentMotorBrand(index)
                                                            setControlTypes(item.controls)
                                                            loadRemote(item.controls)
                                                            setControl(undefined)
                                                            setWifiControl(false)
                                                            scrollToParentEnd('motorBrand')
                                                        }}
                                                        >
                                                            
                                                                <img
                                                                
                                                                    className="object-center object-cover w-1/2 aspect-square p-1"
                                                                    alt=""
                                                                    src={item.src}
                                                                />
                                                    
                                                            <span className='text-sm my-2'>{item.title}</span>
                                                        </div>
                                        
                                                )
                                        })}
                                    
                                    </div>
                                </div>
                               
                                
                                <div className={`w-full mt-5 mb-5 flex flex-col ${(currentControlType==1 && currentMotorBrand!= null) ? '':'hidden'}`}>
                                    <span className='hedvig-letters-sans-regular text-xl text-black mb-3'>Power by:</span>
                                    <span className='hedvig-letters-sans-regular text-base text-neutral-500 mb-2'>Blinds powered by electricity will require an electrician.</span>
                                    <div className='flex flex-row gap-3'>
                                        {powerType?.map((item:any,index:number) =>{
                                                return(
                                                
                                                        <div
                                                        key={index}
                                                        
                                                        className={`bg-white w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(currentPowerType == index)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setCurrentPowerType(index)
                                                        
                                                        }}
                                                        >
                                                            
                                                                <img
                                                                
                                                                    className="object-center object-cover w-1/3 aspect-square p-1"
                                                                    alt=""
                                                                    src={item.src}
                                                                />
                                                    
                                                            <span className='text-sm my-2'>{item.title}</span>
                                                        </div>
                                        
                                                )
                                        })}
                                    
                                    </div>
                                </div>
                                <div className={`w-full mt-5 mb-5 flex flex-col ${(currentControlType==1 && currentMotorBrand!= null) ? '':'hidden'}`} id='remote'>
                                    <span className='hedvig-letters-sans-regular text-xl text-black mb-3'>Remote:</span>
                                    {(loadingRemote)?
                                                    <div className='flex items-center justify-center'>
                                                         <LoadingOutlined color="#000000" style={{fontSize:40}}/>
                                                    </div>
                                                   
                                                    :
                                    <div className='grid grid-cols-2 xl:grid-cols-3 gap-3'>
                                        {controlTypes?.map((item:any,index:number) =>{
                                                return(
                                                
                                                        <div
                                                        key={index}
                                                        className={`bg-white cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(control == index)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setControl(index)
                                                            scrollToParentEnd('remote')
                                                        }}
                                                        >
                                                            
                                                                <img
                                                                
                                                                    className="object-center h-[10rem]  p-1"
                                                                    alt=""
                                                                    src={item.src}
                                                                />
                                                    
                                                            <span className='text-sm my-2'>{item.title}</span>
                                                        </div>
                                        
                                                )
                                        })}
                                    
                                    </div>}
                                </div>
                                <div className={`w-full mt-5 mb-5 flex flex-col ${(currentControlType==1 ) ? '':'hidden'}`}>
                                    <span className='hedvig-letters-sans-regular text-xl text-black mb-3'>Wifi Connection:</span>
                                
                                    <div className='flex flex-row gap-3'>
                                      
                                                
                                                        <div
                                                
                                                        style={{ height:200}}
                                                        className={`bg-white w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(wifiControl == false)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setWifiControl(false)
                                                        }}
                                                        >
                                                            <span className='text-xl my-2'>NO</span>
                                                        </div>
                                                        <div
                                                
                                                        style={{ height:200}}
                                                        className={` bg-white w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(wifiControl == true)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setWifiControl(true)
                                                        }}
                                                        >
                                                            
                                                                <img
                                                                
                                                                    className="object-center object-cover h-5/6  p-1"
                                                                    alt=""
                                                                    src={CFCDN+'protecta/control/alpha-neo1.jpg'}
                                                                />
                                                    
                                                            <span className='text-sm my-2'>Alpha Neo Link Box</span>
                                                        </div>
                                                      
                                    </div>
                                </div>
                                    </div>
                                    }]}
                                />
                                
                                
                                
                    </div>
                    </div> 
                </div>
                </div>
                
               

                <div className='flex flex-col max-w-screen-2xl m-auto items-center justify-center mt-20 mb-10'>
                    <span className='text-2xl lg:text-5xl text-center hedvig-letters-serif-regular'>
                        Need help from our expert?
                    </span>
                    <span className='text-2xl text-center hedvig-letters-sans-regular underline transition-all duration-200 hover:translate-x-1 hover:text-neutral-500 mt-3'
                        onClick={()=>{navigate('/contact')}}
                    >
                        Contact us
                    </span>
                    
                </div>
            </Content>
         
        </div>
  )
}
